import { combineReducers } from 'redux'

import list from './list/slice'

const recommendationsReducer = combineReducers({
  list,
})

export default recommendationsReducer
